/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FinishedGoodArticleItem } from '../../models/finished-good-article-item';

export interface GetFinishedGoodArticles$Params {
  workCenterId: number;
  loadOnlyForActiveOrder: boolean;
}

export function getFinishedGoodArticles(http: HttpClient, rootUrl: string, params: GetFinishedGoodArticles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FinishedGoodArticleItem>>> {
  const rb = new RequestBuilder(rootUrl, getFinishedGoodArticles.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
    rb.path('loadOnlyForActiveOrder', params.loadOnlyForActiveOrder, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FinishedGoodArticleItem>>;
    })
  );
}

getFinishedGoodArticles.PATH = '/api/v1/QualityHistory/{workCenterId}/GetFinishedGoodArticles/{loadOnlyForActiveOrder}';
